import { api, handleResponse, handleError } from "./apiServices";
export const getSubscriptionAllDetails = token => {
  return api(token)
    .get(`/api/subscription_package/package/allDetails`)
    .then(handleResponse)
    .catch(handleError);
};

export const editSubscriptionPackage = (token, id, data) => {
  return api(token)
    .post(`/api/subscription_package/package/edit/${id}`, data)
    .then(handleResponse)
    .catch(handleError);
};

export const ChangeAutoRenew = (token, data) => {
  return api(token)
    .post(`/api/subscription/merchant/update_autorenew`, data)
    .then(handleResponse)
    .catch(handleError);
};
